module.exports = __webpack_public_path__ + "static/media/mukul.e2d77663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/mukul.jpg
// module id = 180
// module chunks = 0